var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiveV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00389 13.7169H14.8592C15.6912 13.7169 16.199 14.4656 15.9256 15.2692C15.7693 15.7307 15.3904 15.994 14.8631 15.9974C13.2577 16.0009 13.6522 16.0009 12.0468 15.9974C7.76171 15.9974 5.47664 15.9974 1.19157 15.9974C0.457213 15.9974 -0.00762078 15.5427 9.45881e-05 14.8383C0.00800388 14.1682 0.465025 13.7169 1.1486 13.7169C4.10167 13.7134 5.05474 13.7134 8.00389 13.7169Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71183 7.81484V7.32856C6.71183 4.76995 6.70797 3.88341 6.71568 1.32481C6.71954 0.333535 7.6065 -0.261229 8.52046 0.112836C9.07963 0.341016 9.28788 0.789895 9.28402 1.35847C9.28017 3.90212 9.28402 4.77369 9.28402 7.32108V7.87095C9.44985 7.72881 9.55782 7.65025 9.65038 7.56048C10.0746 7.14152 10.4911 6.71509 10.923 6.30362C11.4706 5.78367 12.2766 5.76122 12.7933 6.23255C13.3139 6.71135 13.3216 7.53803 12.774 8.08043C11.5053 9.32607 10.2327 10.5642 8.94852 11.7874C8.38549 12.3223 7.61036 12.3261 7.05119 11.7912C5.76702 10.5642 4.49056 9.32981 3.22953 8.08417C2.67807 7.54177 2.68192 6.71883 3.20253 6.23629C3.72314 5.75374 4.52912 5.79115 5.10372 6.32606C5.62047 6.80861 6.14108 7.28741 6.71183 7.81484Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveV2);
export default __webpack_public_path__ + "static/media/Receive_v2.7a05876c.svg";
export { ForwardRef as ReactComponent };